import bronzeCopper from '../images/typefaces/bronzeCopper.png';
import starryMetalmark from '../images/typefaces/starryMetalmark.png';
import alvaLongtail from '../images/typefaces/alvaLongtail.png';
import darkSaliana from '../images/typefaces/darkSaliana.png';

import darkCycadian from '../images/typefaces/darkCycadian.png';
import mourningCloak from '../images/typefaces/mourningCloak.png';
import ilusSwallowtail from '../images/typefaces/ilusSwallowtail.png';
import goldenMelwhite from '../images/typefaces/goldenMelwhite.png';
import sootywingPholisora from '../images/typefaces/sootywingPholisora.png'

const typefaces = [
    {
        "name": "Bronze Copper",
        "pageName": "bronze-copper",
        "src": bronzeCopper,
        "description": "our title font, a classic serif",
        "alt": "bronze copper, a classic serif",
        "hrefPoster": "https://live.staticflickr.com/65535/55520478766_203e2e9a84_b.jpg",
        "altPoster": "a vintage magazine style spread highlighting the typeface, with a large title reading bronze copper, subtitled a new typeface by cerasus. There is a large vintage magazine scan of a woman in a fancy hat",
        "href": "https://github.com/cerasus-creative-studios/bronze-copper"
    },
    {
        "name": "Starry Metalmark",
        "pageName": "starry-metalmark",
        "src": starryMetalmark,
        "description": "a funky street style accent typeface",
        "alt": "starry metalmark, a funky street style accent typeface",
        "hrefPoster": "https://live.staticflickr.com/65535/55520672058_376fe1525b_b.jpg",
        "altPoster": "starry metalmark",
        "href": "https://github.com/cerasus-creative-studios/starry-metalmark.git"
    },
    {
        "name": "Alva Longtail",
        "pageName": "alva-longtail",
        "src": alvaLongtail,
        "description": "a scrawled typeface with high peaks and low valleys",
        "alt": "alva longtail, a scrawled handwritten typeface with high peaks and low valleys",
        "hrefPoster": "https://live.staticflickr.com/65535/55519555297_7ea28f790a_b.jpg",
        "altPoster": "a central circle with a pink creature in the center, surrounded by 8 butterflies flying around in the circle",
        "href": "https://github.com/cerasus-creative-studios/alva-longtail"
    },
    {
        "name": "Dark Saliana",
        "pageName": "dark-saliana",
        "src": darkSaliana,
        "description": "a bold and blocky body font",
        "alt": "dark saliana, a bold and blocky body font",
        "hrefPoster": "https://live.staticflickr.com/65535/55520947330_3f7a6c86a9_b.jpg",
        "altPoster": "dark saliana",
        "href": "https://github.com/cerasus-creative-studios/dark-saliana"
    },
    {
        "name": "Dark Cycadian",
        "pageName": "dark-cycadian",
        "src": darkCycadian,
        "description": "a bold, rounded header font",
        "alt": "dark cycadian, a bold, rounded header font",
        "hrefPoster": "https://live.staticflickr.com/65535/55520947325_7d22e44c07_b.jpg",
        "altPoster": "dark cycadian",
        "href": "https://github.com/cerasus-creative-studios/dark-cycadian"
    },
        {
        "name": "Ilus Swallowtail",
        "pageName": "ilus-swallowtail",
        "src": ilusSwallowtail,
        "description": "a sweeping, cursive script typeface",
        "alt": "ilus swallowtail, a sweeping, cursive script typeface",
        "hrefPoster": "https://live.staticflickr.com/65535/55520720504_5730119992_b.jpg",
        "altPoster": "ilus swallowtail",
        "href": "https://github.com/cerasus-creative-studios/ilus-swallowtail"
    },
    {
        "name": "Mourning Cloak",
        "pageName": "mourning-cloak",
        "src": mourningCloak,
        "description": "a gothic, blocky accent typeface",
        "alt": "mourning cloak, a gothic, blocky accent typeface",
        "hrefPoster": "https://live.staticflickr.com/65535/55522254399_74b9883cdd_b.jpg",
        "altPoster": "mourning cloak",
        "href": "https://github.com/cerasus-creative-studios/mourning-cloak"
    },
    {
        "name": "Golden Melwhite",
        "pageName": "golden-melwhite",
        "src": goldenMelwhite,
        "description": "a typeface designed to look like typewritten ink on paper",
        "alt": "golden melwhite, a typeface designed to look like typewritten ink on paper",
        "hrefPoster": "https://live.staticflickr.com/65535/55522482015_7ac39157ca_b.jpg",
        "altPoster": "golden melwhite",
        "href": "https://github.com/cerasus-creative-studios/golden-melwhite"
    },
    {
        "name": "Sootywing Pholisora",
        "pageName": "sootywing-pholisora",
        "src": sootywingPholisora,
        "description": "a typeface designed to look like typewritten ink on paper",
        "alt": "golden melwhite, a typeface designed to look like typewritten ink on paper",
        "hrefPoster": "https://live.staticflickr.com/65535/55522204773_aa82f34ce6_b.jpg",
        "altPoster": "sootywing pholisora",
        "href": "https://github.com/cerasus-creative-studios/sootywing-pholisora"
    },
]

export default typefaces;